import React, { useRef, useState, useEffect } from "react";
import { Stage, Layer, Text, Rect, Image as KonvaImage } from "react-konva";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ChaseFloorPLan from "../../../assets/ChaseFloorPlan.png";
import Thrivecity from "../../../assets/Thrivecity.png";
import styled from "styled-components";
import { Icon } from "@vds/icons";
import { ButtonGroup } from "@vds/buttons";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";
//import AlertIcon from "../../../assets/alert.svg"
import AlertInWhite from "../../../assets/alertWhite.svg";
import DashboardEventRow from "../events/DashboardEventRow.jsx";
import {
  TimeOfEvent,
  NameOfTheEvent,
  SummaryofEvent,
  CameraNameofEvent,
} from "../events/styles.jsx";
import ShareEvents from "../Modals/ShareEvents.jsx";
import { useNavigate } from "react-router-dom";
import { getCameraLocationForGivenID } from "../../../model/reportService.js";
import Draggable from "react-draggable";
import GmtToLocal from "../../utility/GmtToLocal.js";
import { getEventDescription } from "../../utility/incidentsUtils.js";
import { setDeviceNameEndPoint } from "../../../configuration.js";
import { getRandomUUID } from "../../../Token.js";
import { useLocation } from "react-router-dom";
import {
  ImageContainer,
  Container,
  Button,
  ImageStyle,
  MapControls,
  Expand,
  MarkerStyle,
  CriticalMarkerStyle,
  CustomTooltip,
  EditIconForFP,
  TickIconForFP,
  CloseIconForFP,
  ZoomButtonsBox,
  Edit,
} from "./styles.jsx";
import {
  filterCameraListBasedOnTag,
  getEventsIconOnPriorityTile,
} from "../../../model/DashboardFilterService.js";
import floorPlanCameraIcon from "../../../assets/floorPlanCameraIcon.svg";
import axiosInstance from "../../axiosInterceptor";
import { getImageObj } from "../../utility/Utils.js";

// Pre-load camera icon
const preloadedCameraIcon = new window.Image();
preloadedCameraIcon.src = floorPlanCameraIcon;

// Custom hook to load an image with optional preloaded image
const useImage = (url, preloadedImage = null) => {
  const [image, setImage] = useState(preloadedImage);

  useEffect(() => {
    // If preloaded image is provided and already complete
    if (preloadedImage && preloadedImage.complete) {
      setImage(preloadedImage);
      return;
    }

    // else, load image normally
    const img = preloadedImage || new window.Image();
    img.src = url;
    
    if (img.complete) {
      setImage(img);
    } else {
      img.onload = () => {
        setImage(img);
      };
    }
  }, [url, preloadedImage]);

  return image;
};

const FloorPlan = ({
  cameras,
  showHazard,
  widgetSize,
  isEditable,
  floorImage,
  floorId,
  selectedFloorImage,
  containerHeight,
  dashboard,
  eventDatas,
  eventCheck,
  FloorSize,
  unPairedCam,
  onChangeCamPosition,
  isReview = false,
  isManual = false,
}) => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const criticalEvents = useSelector(
    (state) => state.eventReducer.criticalEvents
  );
  const [originalWidth, orginalHeight] = FloorSize || [595, 295];
  const allEventsData = useSelector((state) => state.eventReducer.allEvents);
  const cvAppsFromReducer = useSelector(
      (state) => state.cvAppReducer.cvAppList
    );
  const navigate = useNavigate();
  const [showTooltip, setShowTooltip] = useState(false);
  const [showShareEvents, setShowShareEvents] = useState({ isOpen: false });
  const [criticalEventsData, setCriticalEventsData] = useState([]);
  const [eventsallData, seteventsData] = useState([]);
  const [eventIds, setEventIds] = useState([]);
  const [availableVideoEvidence, setAvailableVideoEvidence] = useState([]);
  const [evidenceVideoUrl, setEvidenceVideoUrl] = useState(null);
  const [videoEvidences, setVideoEvidences] = useState([]);
  const [showAdditionalButtons, setShowAdditionalButtons] = useState(false);
  const [isEditMode, setIsEditMode] = useState(true);
  const [updatedPosition, setUpdatedPosition] = useState({});
  const [initialMarkers, setInitialMarkers] = useState([]);
  const baseUrl = window.REACT_APP_BASE_URL || "";
  const location = useLocation();
  const [isDashboard, setIsDashboard] = useState(false);

  let stageWidth = originalWidth ? originalWidth : 595;
  let stageHeight = orginalHeight ? orginalHeight : 295;
  const [scale, SetScale] = useState(1);
  const stageRef = useRef(null);

  // Initial sizes
  const initialBackgroundSize = { width: stageWidth, height: stageHeight };
  const initialForegroundSize = { width: 50, height: 50 };
  const [fullScreen, setFullScreen] = useState(false);
  // const [screenStatus, setScreenStatus] = useState(false);
  var screenStatus = false;
  var screenmode = false;

  // State for background and foreground images
  const [backgroundSize, setBackgroundSize] = useState(initialBackgroundSize);
  const [foregroundSize, setForegroundSize] = useState(initialForegroundSize);

  // State for foreground image position
  const [position, setPosition] = useState(() => {
    return unPairedCam
      ? {
          x: unPairedCam?.customdata.cameralocation?.top,
          y: unPairedCam?.customdata.cameralocation?.left,
        }
      : { x: 150, y: 150 };
  });

  const backgroundImage = useImage(floorImage);
  const foregroundImage = useImage(floorPlanCameraIcon, preloadedCameraIcon);
  const allReady = !!backgroundImage && !!foregroundImage;

  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [iconPosition, setIconPosition] = useState({ x: 0, y: 0 });
  const [tooltipText, setTooltipText] = useState("");
  const textRef = useRef();
  const [textSize, setTextSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (location.pathname === "/dashboard") {
      setIsDashboard(true);
    } else {
      setIsDashboard(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (allEventsData && allEventsData.length > 0) {
      let allEventsDataourceIds = [];
      const mappedData = allEventsData
        .map((event) => {
          if (event && event.hasOwnProperty("evidences")) {
            allEventsDataourceIds.push(event?.evidences[0]?.sourceId);
            const cvAppList = cvAppsFromReducer; 
            const findAppName = cvAppList?.filter(
              (cvApp) => cvApp?.image === event.applicationId
            );
            const appName = findAppName?.length ? findAppName[0]?.name : "";
            return {
              timeOfEvent: event.createdAt,
              nameOfEvent:
                appName === "IntrusionDetection" ? "Restricted Area" : appName,
              summaryOfEvent: getEventDescription(
                event?.applicationId,
                event?.deviceLoc,
                event?.description
              ),
              cameraId: event?.evidences[0]?.sourceId,
              priority: event?.priority,
              videoEvidences: event?.evidences[0]?.id,
              status: event?.status,
              createdAt: event?.createdAt,
              description: event?.description,
              updatedAt: event?.updatedAt,
              id: event?.id,
              deviceLoc: event?.deviceLoc,
              evidences: event?.evidences[0],
              applicationId: event?.applicationId,
              evidenceStatus: event?.evidenceStatus ?? null,
              type: event?.type ?? "Incident",
            };
          }
          return null;
        })
        .filter((event) => event !== null); // Ensure we filter out null values

      setEventIds(allEventsDataourceIds);
      seteventsData(mappedData);
      console.log(mappedData, "this is mapped data");
      setVideoEvidences(
        allEventsData[0]?.evidences?.filter(
          (evidence) => evidence.mediaType === "video"
        )
      );
    }
  }, [allEventsData]);

  const defaultCameraList = unPairedCam ? [unPairedCam] : [];
  const cameraList =
    cameras?.length > 0
      ? filterCameraListBasedOnTag(cameras, floorId)
      : defaultCameraList;

  const transformWrapperRef = useRef(null);
  const imageContainerRef = useRef(null);
  const [markers, setMarkers] = useState(() => {
    if (cameraList && cameraList.length > 0) {
      return cameraList.map((camera, index) => ({
        top: camera.customdata?.cameralocation?.top || 50, //Set the default location to centre of the image
        left: camera.customdata?.cameralocation?.left || 50, //Set the default location to centre of the image
        data: camera.name,
        id: camera.id,
      }));
    }
  });

  useEffect(() => {
    handlePosition(stageWidth, stageHeight, floorId);
  }, [floorId]);

  useEffect(() => {
    if (tooltipVisible && textRef.current) {
      setTextSize({
        width: textRef.current.width(),
        height: textRef.current.height(),
      });
    }
  }, [tooltipVisible]);

  // useEffect(() => {
  //   const stage = stageRef.current;
  //   const oldScale = stage.scaleX();
  //   const newScale = oldScale * 1.2;
  //   SetScale(newScale);
  //   setBackgroundSize({ width: window.innerWidth, height: window.innerHeight });
  //   const position = handlePosition(
  //     window.innerWidth,
  //     window.innerHeight,
  //     floorId
  //   );
  //   if (position && position.length) {
  //     const x = position[0].top - stage.x();
  //     const y = position[0].left - stage.y();
  //     setIconPosition({
  //       x: position[0].top - x * newScale,
  //       y: position[0].left - y * newScale,
  //     });
  //     //console.log(position, {x:position[0].top-x * newScale,y: position[0].top-y * newScale}, "position >>");
  //   }
  // }, [widgetSize]);

  const handlePosition = (width, height, floorId) => {
    const cameraList =
      cameras?.length > 0
        ? filterCameraListBasedOnTag(cameras, floorId)
        : defaultCameraList;
    const initialMarkers = cameraList.map((camera, index) => ({
      top:
        handleResize(
          width,
          height,
          camera.customdata?.cameralocation?.top,
          camera.customdata?.cameralocation?.left
        )?.x || 50,
      left:
        handleResize(
          width,
          height,
          camera.customdata?.cameralocation?.top,
          camera.customdata?.cameralocation?.left
        )?.y || 50,
      data: camera.name,
      id: camera.id,
    }));
    setMarkers(initialMarkers);
    setInitialMarkers(initialMarkers); // Store initial positions
    return initialMarkers;
  };

  const handleResize = (newWidth, newHeight, TopX, LeftY) => {
    // Calculate the scaling ratio for the background
    const widthRatio = newWidth / 464;
    const heightRatio = newHeight / 332;

    // Recalculate foreground positions based on the background scaling
    const newX = TopX * widthRatio;
    const newY = LeftY * heightRatio;

    // Update states
    // setBackgroundSize({ width: newWidth, height: newHeight });
    // setPosition({ x: newX+40, y: newY+30 });
    // console.log(screenmode,">>> screen");
    return {
      x: screenmode ? newX + 50 : newX,
      y: screenmode ? newY + 30 : newY,
    };
  };
  const toggleFullscreen = () => {
    const imageContainer = imageContainerRef.current;
    setFullScreen(true);
    screenmode = true;
    handlePosition(window.innerWidth, window.innerHeight, floorId);
    setBackgroundSize({ width: window.innerWidth, height: window.innerHeight });
    if (imageContainer) {
      console.log("Full Screen");
      if (imageContainer.requestFullscreen) {
        console.log("Full Screen");
        imageContainer.requestFullscreen().catch((err) => {
          console.error(
            "Error attempting to enable full-screen mode:",
            err.message
          );
        });
      } else if (imageContainer.mozRequestFullScreen) {
        imageContainer.mozRequestFullScreen();
      } else if (imageContainer.webkitRequestFullscreen) {
        imageContainer.webkitRequestFullscreen();
      } else if (imageContainer.msRequestFullscreen) {
        imageContainer.msRequestFullscreen();
      }
      //handelMarkerData(4,8, true);
    }
    var newHandle = function (event) {
      exitHandler(event, screenStatus);
    };
    setTimeout(() => {
      screenStatus = true;
    }, 1000);
    if (document.addEventListener) {
      document.addEventListener("fullscreenchange", newHandle, false);
      document.addEventListener("mozfullscreenchange", newHandle, false);
      document.addEventListener("MSFullscreenChange", newHandle, false);
      document.addEventListener("webkitfullscreenchange", newHandle, false);
    }
  };
  const exitHandler = (e, status) => {
    if (status) {
      screenmode = false;
      setFullScreen(false);
      setBackgroundSize({ width: stageWidth, height: stageHeight });
      handlePosition(stageWidth, stageHeight, floorId);
      screenStatus = false;
    }
  };

  const zoomIn = () => {
    const stage = stageRef.current;
    const oldScale = stage.scaleX();
    const newScale = oldScale * 1.2;
    SetScale(newScale);
  };

  const zoomOut = () => {
    const stage = stageRef.current;
    const oldScale = stage.scaleX();
    const newScale = oldScale * 0.8;
    SetScale(newScale);
  };

  const handleEventData = (cameraid, eventInfo = false) => {
    const filteredEvents = eventsallData.filter(
      (event) => event.cameraId === cameraid
    );
    if (filteredEvents.length > 0) {
      if (eventInfo) {
        navigate(`/eventsInfo?eventid=${filteredEvents[0]?.id}`);
      } else {
        return filteredEvents[0];
      }
    } else {
      return [];
    }
  };

  const onEditClickHandler = () => {
    setShowAdditionalButtons(!showAdditionalButtons);
    setIsEditMode(!isEditMode);
    if (isEditMode) {
      resetMarkers();
    }
  };

  const handleMouseEnter = (e, name) => {
    const pos = e.target.getStage().getPointerPosition();
    setTooltipPosition({ x: pos.x + 10, y: pos.y + 10 });
    setTooltipText(name);
    setTooltipVisible(true);
  };

  const handleMouseMove = (e) => {
    const pos = e.target.getStage().getPointerPosition();
    setTooltipPosition({ x: pos.x + 10, y: pos.y + 10 });
  };

  const resetMarkers = () => {
    setMarkers(initialMarkers);
  };
const getDragBoundFunc = () => {
  return (pos) => {
    // Clamp the marker within the background image boundaries
    const minX = 0;
    const minY = 0;
    const maxX = backgroundSize.width - foregroundSize.width;
    const maxY = backgroundSize.height - foregroundSize.height;

    return {
      x: Math.max(minX, Math.min(pos.x, maxX)),
      y: Math.max(minY, Math.min(pos.y, maxY)),
    };
  };
};
  const updateMarkerPosition = (index, x, y) => {
    setMarkers((prevMarkers) =>
      prevMarkers.map((marker, idx) =>
        idx === index ? { ...marker, left: y, top: x } : marker
      )
    );
  };

  const onCheckMarkClickHandler = async () => {
    onChangeCamPosition({ top: position.x, left: position.y });
    if (unPairedCam) {
      setShowAdditionalButtons(false);
      return;
    }
    const response = await axiosInstance.patch(setDeviceNameEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: { deviceId: cameraList[0].uid },
      device: {
        customdata: {
          cameralocation: {
            top: position.x,
            left: position.y,
          },
        },
      },
    });
    if (response.status === 200) {
      console.log(response, "marker position updated successfully");
      setIsEditMode(false);
      setShowAdditionalButtons(false);
    } else if (response.status === 400) {
      console.error();
    }
  };

  const isPositionChanged =
    unPairedCam &&
    (unPairedCam?.customdata.cameralocation?.top != position.x ||
      unPairedCam?.customdata.cameralocation?.left != position.y);

  return (
    <Container>
      <div
        style={{ width: "100%", height: "100%", position: "relative" }}
        ref={imageContainerRef} //ref is used to get the height and width of this container
      >
        <>
          {/* {isEditable && (
            <EditIconForFP>
              <Edit>
                <Button onClick={onEditClickHandler}>
                  <Icon name="edit" surface="light" size="large" />
                </Button>
              </Edit>
            </EditIconForFP>
          )} */}
          {(showAdditionalButtons || isPositionChanged) &&
            !isReview &&
            !isManual && (
              <>
                <TickIconForFP>
                  <Button onClick={onCheckMarkClickHandler}>
                    <Icon name="checkmark" surface="light" size="large" />
                  </Button>
                </TickIconForFP>

                <CloseIconForFP>
                  <Button onClick={resetMarkers}>
                    <Icon name="close" surface="light" size="large" />
                  </Button>
                </CloseIconForFP>
              </>
            )}
          <Stage
            width={fullScreen ? window.innerWidth : stageWidth}
            height={fullScreen ? window.innerHeight : stageHeight}
            style={{ border: "1px solid grey" }}
            scaleX={scale}
            scaleY={scale}
            ref={stageRef}
            onClick={(e) => e.evt.stopPropagation()}
            onMouseDown={(e) => e.evt.stopPropagation()}
            // x={iconPosition.x}
            // y={iconPosition.y}
            Draggable={false}
          >
            <Layer>
              {allReady && (
                <>
                <KonvaImage
                  image={backgroundImage}
                  x={0}
                  y={0}
                  width={backgroundSize.width}
                  height={backgroundSize.height}
                />
              {markers?.map((marker, index) => {
                if (
                  (eventCheck && eventIds.includes(marker?.id)) ||
                  (eventCheck && eventDatas && Object.keys(eventDatas)?.length)
                ) {
                  const eventData =
                    eventDatas && Object.keys(eventDatas)?.length
                      ? eventDatas
                      : handleEventData(marker?.id);

                  return (
                    <>
                      {/* <Tooltip key={index} title={marker.data} arrow> */}
                      <KonvaImage
                        onClick={() => {
                          handleEventData(
                            marker?.id,
                            eventDatas && Object.keys(eventDatas)?.length
                              ? false
                              : true
                          );
                        }}
                        image={getEventsIconOnPriorityTile(eventData)}
                        x={marker?.top}
                        y={marker?.left}
                        width={foregroundSize.width}
                        height={foregroundSize.height}
                        onMouseEnter={(e, name) => {
                          handleMouseEnter(e, marker?.data);
                        }}
                        onMouseMove={handleMouseMove}
                        onMouseLeave={() => {
                          setTooltipVisible(false);
                        }}
                        onDragEnd={(e) => {
                          setPosition({
                            x: e.target.x(),
                            y: e.target.y(),
                          });
                          onChangeCamPosition({
                            top: e.target.x(),
                            left: e.target.y(),
                          });
                        }}
                      />
                      {/* </Tooltip> */}
                    </>
                  );
                } else {
                  if ((isEditable && isEditMode) || unPairedCam) {
                    return (
                      // <Tooltip title={marker.data} arrow>
                      <KonvaImage
                        image={foregroundImage}
                        x={marker?.top}
                        y={marker?.left}
                        width={foregroundSize.width}
                        height={foregroundSize.height}
                        {...(!isReview && { Draggable })}
                        dragBoundFunc={getDragBoundFunc()}
                        onDragEnd={(e) => {
                          setPosition({
                            x: e.target.x(),
                            y: e.target.y(),
                          });
                          updateMarkerPosition(
                            index,
                            e.target.x(),
                            e.target.y()
                          );
                          onChangeCamPosition({
                            top: e.target.x(),
                            left: e.target.y(),
                          });
                        }}
                      />
                      // </Tooltip>
                    );
                  } else {
                    return (
                      <>
                        {/* <Tooltip key={index} title={marker.data} arrow> */}
                        <KonvaImage
                          onClick={() => {
                            handleEventData(
                              marker?.id,
                              eventDatas && Object.keys(eventDatas)?.length
                                ? false
                                : true
                            );
                          }}
                          image={foregroundImage}
                          x={marker?.top}
                          y={marker?.left}
                          width={foregroundSize.width}
                          height={foregroundSize.height}
                          onMouseEnter={(e, name) => {
                            handleMouseEnter(e, marker?.data);
                          }}
                          onMouseMove={handleMouseMove}
                          onMouseLeave={() => {
                            setTooltipVisible(false);
                          }}
                          onDragEnd={(e) => {
                            setPosition({
                              x: e.target.x(),
                              y: e.target.y(),
                            });
                            onChangeCamPosition({
                              top: e.target.x(),
                              left: e.target.y(),
                            });
                          }}
                        />
                      </>
                    );
                  }
                }
              })}
              {tooltipVisible && (
                <>
                  <Rect
                    x={tooltipPosition.x}
                    y={tooltipPosition.y}
                    width={textSize.width + 10} // Add some padding
                    height={textSize.height + 10} // Add some padding
                    fill="white"
                    cornerRadius={4}
                  />
                  <Text
                    ref={textRef}
                    text={tooltipText}
                    x={tooltipPosition.x + 5} // Adjust based on padding
                    y={tooltipPosition.y + 5} // Adjust based on padding
                    fontSize={16}
                    fill="Black"
                    padding={5}
                  />
                </>
              )}
              </>
              )}
            </Layer>
          </Stage>
          {!fullScreen && !isReview && !isEditable && !isEditMode && (
            <MapControls>
              <ZoomButtonsBox>
                <Button
                  onClick={() => {
                    zoomIn();
                  }}
                >
                  <Icon name="zoom-in" surface="light" size="medium" />
                </Button>
                <Button
                  onClick={() => {
                    zoomOut();
                  }}
                >
                  <Icon name="zoom-out" surface="light" size="medium" />
                </Button>
              </ZoomButtonsBox>
              <Expand>
                <Button onClick={toggleFullscreen}>
                  <Icon name="fit-to-zone" surface="light" size="medium" />
                </Button>
              </Expand>
            </MapControls>
          )}
        </>
      </div>
    </Container>
  );
};

export default FloorPlan;
